const MissionPC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="212"
      height="200.504"
      viewBox="0 0 212 200.504"
    >
      <g transform="translate(-575.893 -182.548)">
        <path
          d="M580.773,207.916V184.948h8.843v22.738c0,6.546,3.273,9.933,8.67,9.933s8.67-3.273,8.67-9.646V184.948H615.8v22.681c0,12.173-6.833,18.144-17.627,18.144S580.773,219.744,580.773,207.916Z"
          transform="translate(-1.378 -0.677)"
          fill="#00a26a"
        />
        <path
          d="M644.453,197.842h8.727v4.364c2.01-2.584,4.593-4.938,9.015-4.938,6.6,0,10.451,4.364,10.451,11.426v19.925h-8.728V211.451c0-4.134-1.951-6.259-5.282-6.259s-5.455,2.124-5.455,6.259v17.168h-8.727Z"
          transform="translate(-19.353 -4.155)"
          fill="#00a26a"
        />
        <path
          d="M698.452,182.548h8.727v41.916h-8.727Z"
          transform="translate(-34.596)"
        />
        <path
          d="M723.57,213.4v-.115c0-8.842,7.121-16.02,16.709-16.02,9.531,0,16.594,7.062,16.594,15.905v.115c0,8.842-7.121,16.02-16.709,16.02C730.633,229.308,723.57,222.245,723.57,213.4Zm24.69,0v-.115c0-4.536-3.273-8.5-8.1-8.5-5,0-7.981,3.846-7.981,8.383v.115c0,4.536,3.273,8.5,8.1,8.5C745.275,221.786,748.26,217.939,748.26,213.4Z"
          transform="translate(-41.686 -4.155)"
        />
        <path
          d="M778.689,213.4v-.115a15.8,15.8,0,0,1,16.135-16.02c5.8,0,9.417,1.952,12.288,5.168l-5.34,5.742c-1.953-2.068-3.905-3.388-7.006-3.388-4.364,0-7.464,3.846-7.464,8.383v.115c0,4.708,3.043,8.5,7.809,8.5,2.928,0,4.938-1.263,7.063-3.273l5.11,5.168a15.5,15.5,0,0,1-12.575,5.627A15.715,15.715,0,0,1,778.689,213.4Z"
          transform="translate(-57.245 -4.155)"
        />
        <path
          d="M829.751,182.548h8.727v22.336l10.22-11.2h10.45L847.436,205.8l12.116,18.661H849.56l-8.038-12.574-3.043,3.215v9.359h-8.727Z"
          transform="translate(-71.658)"
        />
        <path
          d="M591.339,319.294l-15.446-24.346h10.335l9.589,16.134,9.761-16.134h10.048l-15.445,24.174v16.02h-8.842Z"
          transform="translate(0 -31.728)"
        />
        <path
          d="M631.172,323.4v-.115c0-8.842,7.121-16.02,16.709-16.02,9.531,0,16.594,7.062,16.594,15.905v.115c0,8.842-7.121,16.02-16.709,16.02C638.235,339.308,631.172,332.245,631.172,323.4Zm24.69,0v-.115c0-4.536-3.273-8.5-8.1-8.5-5,0-7.981,3.846-7.981,8.383v.115c0,4.536,3.273,8.5,8.1,8.5C652.877,331.786,655.862,327.939,655.862,323.4Z"
          transform="translate(-15.604 -35.206)"
        />
        <path
          d="M689.652,327.993V308.068h8.727v17.169c0,4.134,1.952,6.259,5.282,6.259s5.455-2.125,5.455-6.259V308.068h8.728v30.777h-8.728v-4.364c-2.01,2.584-4.593,4.938-9.015,4.938C693.5,339.419,689.652,335.055,689.652,327.993Z"
          transform="translate(-32.112 -35.431)"
        />
        <path
          d="M745.01,307.837h8.728v6.2c1.78-4.249,4.651-7.005,9.818-6.775v9.129H763.1c-5.8,0-9.359,3.5-9.359,10.853v11.369H745.01Z"
          transform="translate(-47.738 -35.2)"
        />
        <path
          d="M576.853,404.948h9.762l10.507,28.308,10.508-28.308h9.532l-16.25,40.48H593.1Z"
          transform="translate(-0.271 -62.779)"
        />
        <path
          d="M636.613,439.867v-.115c0-6.718,5.11-9.818,12.4-9.818a21.875,21.875,0,0,1,7.522,1.263v-.517c0-3.617-2.24-5.628-6.6-5.628a22.639,22.639,0,0,0-8.5,1.666l-2.182-6.661a27.154,27.154,0,0,1,11.944-2.469c4.766,0,8.211,1.263,10.393,3.445,2.3,2.3,3.33,5.685,3.33,9.819v17.857H656.48v-3.33a11.833,11.833,0,0,1-9.3,3.9C641.379,449.283,636.613,445.953,636.613,439.867Zm20.039-2.01v-1.55a13.536,13.536,0,0,0-5.57-1.148c-3.732,0-6.029,1.493-6.029,4.249v.115c0,2.354,1.952,3.732,4.766,3.732C653.9,443.254,656.652,441.015,656.652,437.857Z"
          transform="translate(-17.14 -66.346)"
        />
        <path
          d="M690.692,402.548h8.728v41.916h-8.728Z"
          transform="translate(-32.405 -62.101)"
        />
        <path
          d="M719.172,437.993V418.068H727.9v17.169c0,4.134,1.952,6.259,5.282,6.259s5.455-2.124,5.455-6.259V418.068h8.728v30.777h-8.728v-4.364c-2.009,2.584-4.593,4.938-9.015,4.938C723.019,449.419,719.172,445.055,719.172,437.993Z"
          transform="translate(-40.444 -66.482)"
        />
        <path
          d="M769.25,433.4v-.115c0-8.785,6.259-16.02,15.216-16.02,10.278,0,14.987,7.982,14.987,16.709,0,.689-.058,1.493-.115,2.3H777.921a7.138,7.138,0,0,0,7.522,6.029,10.085,10.085,0,0,0,7.464-3.158l5,4.421a15.391,15.391,0,0,1-12.574,5.742C776.083,449.308,769.25,442.82,769.25,433.4Zm21.7-2.585c-.517-3.9-2.813-6.546-6.488-6.546-3.617,0-5.971,2.584-6.66,6.546Z"
          transform="translate(-54.58 -66.256)"
        />
        <path
          d="M821.89,448.149h9.3v9.187h-9.3Z"
          transform="translate(-69.439 -74.973)"
        />
      </g>
    </svg>
  )
}

export default MissionPC
